"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
var _iconsClose = require("../../resources/icons-close.svg");
var _ActionsContainer = _interopRequireDefault(require("../buttons/ActionsContainer"));
var _Button = _interopRequireDefault(require("../buttons/Button"));
var _BreakpointTemplate = _interopRequireDefault(require("../templates/BreakpointTemplate"));
var _templateObject;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Dialog = exports["default"] = /*#__PURE__*/function (_Component) {
  function Dialog(props) {
    var _this;
    _classCallCheck(this, Dialog);
    _this = _callSuper(this, Dialog, [props]);
    _this.state = {
      open: _this.props.open ? _this.props.open : false,
      loadingModel: null //new LoadingModel()
    };
    return _this;
  }
  _inherits(Dialog, _Component);
  return _createClass(Dialog, [{
    key: "setLoading",
    value: function setLoading() {
      //this.loadingModel.setLoading(event, loading);
      //if (this.loadingBar) this.loadingBar.current.setLoading(this.loadingModel.isLoading);
    }
  }, {
    key: "open",
    value: function open(_open) {
      this.setState({
        open: _open !== undefined ? _open : true
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.setState({
        open: false
      });
    }
  }, {
    key: "onBackdropClick",
    value: function onBackdropClick() {}
  }, {
    key: "onClose",
    value: function onClose(e, reason) {
      var onClose = this.props.onClose;
      if (reason === "backdropClick") return;
      if (onClose) onClose(e, reason);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        open = _this$props.open,
        theme = _this$props.theme,
        fixedActions = _this$props.fixedActions,
        onClose = _this$props.onClose,
        fullWidth = _this$props.fullWidth,
        className = _this$props.className,
        title = _this$props.title,
        children = _this$props.children,
        maxWidth = _this$props.maxWidth,
        maxHeight = _this$props.maxHeight,
        actions = _this$props.actions,
        justifyActions = _this$props.justifyActions,
        disabledToBreakpoint = _this$props.disabledToBreakpoint,
        topCloseButton = _this$props.topCloseButton;
      var disabled = disabledToBreakpoint && theme && theme.isBreakpointDown(disabledToBreakpoint);
      return /*#__PURE__*/_react["default"].createElement(StyledConfirmationDialog, {
        className: "klayo-dialog" + (className ? " " + className : ""),
        open: open,
        fullWidth: fullWidth || true,
        fullScreen: theme.isBreakpointDown("md"),
        onBackdropClick: this.onBackdropClick.bind(this),
        onClose: this.onClose.bind(this),
        PaperProps: {
          sx: {
            borderRadius: {
              xs: "0!important",
              sm: "0!important",
              md: "16px!important"
            }
          }
        },
        scroll: fixedActions ? "paper" : "body",
        maxWidth: maxWidth,
        TransitionComponent: Dialog.Transition,
        disableScrollLock: true
      }, title && /*#__PURE__*/_react["default"].createElement(_material.DialogTitle, {
        sx: {
          fontSize: {
            xs: "20px",
            md: "24px"
          },
          lineHeight: {
            xs: "28px",
            md: "32px"
          },
          padding: {
            xs: "26px",
            md: "40px 40px 32px 40px"
          },
          letterSpacing: {
            xs: "-0.3px",
            md: "-0.5px"
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.Stack, {
        direction: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flexGrow: 1
        }
      }, title), topCloseButton && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        icon: /*#__PURE__*/_react["default"].createElement(_iconsClose.ReactComponent, null),
        onClick: onClose,
        sx: {
          display: {
            xs: "block",
            md: "none"
          }
        }
      }))), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, {
        sx: {
          padding: {
            xs: "24px",
            md: "40px"
          },
          maxHeight: maxHeight ? maxHeight : "unset",
          fontSize: "16px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_BreakpointTemplate["default"], {
        theme: theme,
        disabledToBreakpoint: disabledToBreakpoint
      }, children)), (actions || disabled) && /*#__PURE__*/_react["default"].createElement(_material.DialogActions, {
        sx: {
          padding: {
            xs: "24px",
            md: "40px"
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_ActionsContainer["default"], {
        actions: actions,
        justifyActions: justifyActions,
        disabled: disabled,
        onClose: onClose
      })));
    }
  }]);
}(_react.Component);
_defineProperty(Dialog, "defaultProps", {
  topCloseButton: true
});
_defineProperty(Dialog, "Transition", /*#__PURE__*/_react["default"].forwardRef(function Transition(props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_material.Slide, _extends({
    direction: "up",
    ref: ref
  }, props), props.children);
}));
var StyledConfirmationDialog = (0, _styled["default"])(_material.Dialog)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .MuiDialogContent-root {\n  }\n\n  @media (max-width: 900px) {\n    .MuiDialogContent-root {\n      margin: 0px 26px 26px 26px;\n      padding: 0px 0px 20px 0px;\n    }\n  }\n"])));